import React, { useState, useEffect } from "react";
import "./cgCarousel.scss";
import rightArrow from "../assets/Icons/rightArrow.svg";
const CgCarousel = ({
  images,
  selectedPhoto,
  disabled = false, // disbale field
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const imagesPerSlide = 3;

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + imagesPerSlide >= images.length
        ? 0
        : prevIndex + imagesPerSlide
    );
  };

  const handlePhotoSelected = (img, index) => {
    selectedPhoto(img, index);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - imagesPerSlide < 0
        ? images.length - (images.length % imagesPerSlide || imagesPerSlide)
        : prevIndex - imagesPerSlide
    );
  };

  const visibleImages = [];
  for (let i = 0; i < imagesPerSlide; i++) {
    visibleImages.push(images[(currentIndex + i) % images.length]);
  }

  return (
    <div
      className={`${disabled ? "disable" : ""}`}
      style={styles.carouselWrapper}
    >
      {images?.length ? (
        <button className="carouselArrow" onClick={handlePrev}>
          <img src={rightArrow} style={styles.carousel.leftArrow} />
        </button>
      ) : (
        null
      )}
      <div style={styles.carousel}>
        {images
          .slice(currentIndex, currentIndex + imagesPerSlide)
          .map((img, index) => (
            <img
              onClick={() => {
                handlePhotoSelected(img, index);
              }}
              crossOrigin="anonymous"
              key={index}
              src={img}
              alt={`carousel-${index}`}
              style={styles.image}
            />
          ))}
      </div>
      {images?.length ? (
        <button className="carouselArrow" onClick={handleNext}>
          <img src={rightArrow} />
        </button>
      ) : (
        null
      )}
    </div>
  );
};

const styles = {
  carouselWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    width: "630px",
    overflow: "hidden",
    margin: "50px 40px 70px 0px",
  },
  carousel: {
    display: "flex",
    gap: "10px",
    justifyContent: "space-evenly",
    overflow: "hidden",
    width: "500px",
    leftArrow: {
      transform: "rotate(180deg)",
    },
  },
  image: {
    width: "148px",
    height: "148px",
    objectFit: "cover",
    borderRadius: "0px",
    border: "1px solid #d4d4d5",
  },
  button: {
    cursor: "pointer",
    color: "#fff",
    border: "none",
    padding: "10px",
    fontSize: "18px",
    borderRadius: "5px",
  },
};

export default CgCarousel;
